import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getAirwaySelector } from '../selectors'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'
import { IAirwayComplicationPNNVAction } from '../../../intubation/saga/setAirwayComplicationsPNNV.saga'

export function* setAirwayComplicationsPNNV(action: IAirwayComplicationPNNVAction) {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const { inputRows } = procedureState
  const { airwayComplications } = airwayState

  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === AirwayConstants.SET_AIRWAY_COMPLICATIONS) {
        //@ts-ignore
        input.props.savedValues = airwayComplications
        //@ts-ignore
        input.props.savedPNNVValue = action.airwayComplicationsPNNV
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setAirwayComplicationsPNNVSaga() {
  yield takeLatest([AirwayConstants.SET_AIRWAY_COMPLICATIONS_PNNV], setAirwayComplicationsPNNV)
}
